import FeaturedCarousel from "../featured_Carousel/Featured_Carousel"


export default function Hero(){
    return <FeaturedCarousel />
}